import React from 'react';
import styled from 'styled-components';
import commonIconStyles from './commonIconStyles';

const RemoteIcon = styled(props => (
  <svg
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.17 5.7L1 10.48V21h5v-8h4v8h5V10.25z" />
    <path d="M10 3v1.51l2 1.33L13.73 7H15v.85l2 1.34V11h2v2h-2v2h2v2h-2v4h6V3H10zm9 6h-2V7h2v2z" />
  </svg>
))`
  ${commonIconStyles};
`;

export default RemoteIcon;
